<template>
	<div>
		<div
			v-for="(currentData, index) in fileURLArrayNew"
			:key="index"
			v-show="currentIndex === index"
		>
			<div v-if="isImage(currentData.fileDetails.name)" class="image-container">
				<img
					class="uploaded-image"
					:src="currentData.src"
					alt="Image Preview"
					id="preview-img"
				/>
			</div>
			<video
				v-else-if="isVideo(currentData.fileDetails.name)"
				:src="currentData.src"
				controls
				id="preview-video"
				style="width: 100%; height: 500px; object-fit: cover"
			></video>
			<div
				v-else-if="isCSV(currentData.fileDetails.name)"
				style="text-align: center"
			>
				<img
					@click="show_excel(currentData.src)"
					src="../../../../assets/icons/excel.png"
					style="width: 400px; height: 480px; object-fit: cover"
				/>
				<h3>Click on the image to download .csv file</h3>
			</div>
			<div v-else-if="isPDF(currentData.fileDetails.name)">
				<div>
					<PDFViewer
						ref="pdfViewer"
						:source="currentData.src"
						style="width: 100%; height: 500px"
						:key="'pdf_' + index"
						:rendering-text="renderingText"
						@rendered="onPDFRendered(index)"
						@download="handleDownload"
					/>
				</div>
			</div>
			<div
				v-if="fileURLArrayNew.length > 1"
				style="text-align: center; margin-top: 30px"
			>
				<el-button
					@click="prevItem"
					:disabled="currentIndex === 0"
					class="button-class-white"
					icon="el-icon-d-arrow-left"
				>
					Previous
				</el-button>
				<el-button
					style="margin-left: 50px"
					@click="nextItem"
					:disabled="currentIndex === fileURLArrayNew.length - 1"
					class="button-class-white"
					icon="el-icon-d-arrow-right"
				>
					Next
				</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import PDFViewer from "pdf-viewer-vue/dist/vue2-pdf-viewer";
export default {
	components: {
		PDFViewer,
	},
	props: {
		fileURLArray: Array,
	},
	data() {
		return {
			currentIndex: 0,
			renderingText: "Loading...",
			fileURLArrayNew: [],
		};
	},
	mounted() {
		this.fileURLArrayNew = this.fileURLArray;
		this.$forceUpdate();
	},
	methods: {
		renderPage(rotate) {
			if (this.pdfRender) {
				if (this.canceling) {
					return;
				}
				this.canceling = true;
				this.pdfRender
					.cancel()
					.then(() => {
						// Successfully canceled rendering
						// Do something if needed
					})
					.catch((err) => {
						this.emitEvent("error", err);
					});
			}
		},
		isImage(fileName) {
			return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileName);
		},
		isVideo(fileName) {
			return /\.(mp4|mov|wmv|avi|avchd|flv|f4v|swf|mkv|webm|mpg|mp2|mpeg|mpe|mpv|video)$/i.test(
				fileName
			);
		},
		isCSV(fileName) {
			return /\.(csv|sheet)$/i.test(fileName);
		},
		isPDF(fileName) {
			return /\.(pdf)$/i.test(fileName);
		},
		prevItem() {
			if (this.currentIndex > 0) {
				this.currentIndex--;
			}
		},
		nextItem() {
			if (this.currentIndex < this.fileURLArray.length - 1) {
				this.currentIndex++;
			}
		},
		async handleDownload(pdfInfo) {
			try {
				const response = await fetch(pdfInfo.src);
				if (!response.ok) {
					throw new Error("Network response was not ok");
				}
				const pdfData = await response.blob();
				const link = document.createElement("a");
				link.href = window.URL.createObjectURL(pdfData);
				link.download = pdfInfo.filename;
				link.click();
				window.URL.revokeObjectURL(link.href);
			} catch (error) {
				console.error("Error downloading PDF:", error.message);
			}
		},
		onPDFRendered(index, src) {
			console.log(this.$refs.pdfViewer, "pdfViewer");
			console.log("PDF rendered at index:", index);
			setTimeout(() => {
				this.$nextTick(() => {
					this.$forceUpdate();
				});
			}, 100);
		},
		show_excel(excel) {
			window.open(excel);
		},
	},
};
</script>

<style scoped>
.button-class-white {
	height: 40px;
	background: #ffffff;
	border-radius: 12px;
	color: #d26300;
	border: 1px solid #d26300;
	overflow: visible;
	position: relative;
}

.image-container {
	max-width: 100%;
	max-height: 420px;
	overflow-y: auto; /* Set maximum height as per your requirement */
	margin-bottom: 20px; /* Add margin between images */
	text-align: center;
}

.uploaded-image {
	max-width: 100%;
	max-height: 400px;
}
</style>
